/* loaded by smart-asset */
export default "loading-logo-v2~bcJtSGDI.gif"